import { flatten, partition, uniq } from "lodash-es";
import { ItemType } from "../../../clients/graphqlTypes.js";
import { getDefaultCreatableSubItemTypes } from "./constraints.js";

export function getDefaultItemType(
  isRootItem: boolean,
  children: Array<{ type: ItemType }>
): ItemType {
  // 1. The default item type on the top level is SECTION,
  if (isRootItem) {
    return "section";
  }

  // 2. The default item type on any level lower is PAID ITEM IFF no siblings have been created.
  if (children.length === 0) {
    return "paid";
  }

  // 3. When a sibling has been created on a level, then the default item type for new siblings is the SAME ITEM TYPE
  const childrenTypes = uniq(children.map(s => s.type));
  if (childrenTypes.length === 1) {
    return childrenTypes[0];
  }

  return "paid";
}

/**
 * The creatable sub-item types for the combobox, with the default type first.
 * Items backed by a linked template cannot receive manually created children.
 */
export function getOrderedCreatableSubItemTypes({
  item,
  documentItemTypes,
  isRootItem,
  itemChildren,
}: {
  item: { type: ItemType };
  documentItemTypes: ItemType[];
  isRootItem: boolean;
  itemChildren: Array<{ type: ItemType }>;
}): ItemType[] {
  const creatableSubItemTypes =
    "linkedQuoteTemplate" in item && Boolean(item.linkedQuoteTemplate)
      ? []
      : getDefaultCreatableSubItemTypes(item.type, documentItemTypes);
  const defaultItemType = getDefaultItemType(isRootItem, itemChildren);

  return flatten(
    partition(creatableSubItemTypes, type => type === defaultItemType)
  );
}
